import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { Gathering } from "../../entities/gathering.entity";

export class GatheringGetRequestBody extends NaniumObject<GatheringGetRequestBody> {
	@Type(String)	id?: string;
}

@RequestType({
	responseType: Gathering,
	genericTypes: { TRequestBody: GatheringGetRequestBody },
	scope: 'public',
	skipInterceptors: true
})
export class GatheringGetRequest extends ServiceRequestBase<GatheringGetRequestBody, Gathering> {
	static serviceName: string = 'NaniumDemo:gathering/get';
}
